module.exports = __webpack_public_path__ + "static/media/accessory21.3592f07a.webp";